import React from 'react';

interface UserInfoProps {
  imageUrl: string;
  name: string;
  description: string;
}

const UserInfo: React.FC<UserInfoProps> = ({ imageUrl, name, description }) => {
  return (
    <div className="ceas-px-4 ceas-py-5 sm:ceas-px-6">
      <div className="ceas-flex ceas-flex-col ceas-justify-center ceas-items-center">
        <img className="ceas-rounded-full" src={imageUrl} alt="image" />
        <h1 className="ceas-text-2xl ceas-font-medium ceas-text-gray-900">{name}</h1>
        <p className="ceas-mt-1 ceas-max-w-2xl ceas-text-sm ceas-text-gray-500">{description}</p>
      </div>
    </div>
  );
};

export default UserInfo;
